import React from 'react';
import { CheckIcon, CreditCardIcon, LockIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { checkoutChecklist, heroMockup, localCurrencyNote, priceLabel, realValueLabel, savingsLabel } from '../data/content';
export function Checkout() {
  return <section id="checkout" aria-labelledby="checkout-heading" className="scroll-mt-14 bg-cloud" data-id="element-38" data-mp="3eov8c7jdm9i5">
      <div className="mx-auto max-w-4xl px-4 py-12 sm:px-5 lg:py-24" data-id="element-39" data-mp="39ps1chju5t7j">
        <div className="overflow-hidden rounded-xl border-t-4 border-gold bg-white shadow-[0_24px_60px_-40px_rgba(10,26,47,0.5)]" data-id="element-40" data-mp="39mw3subwh6jm">
          <div className="bg-navy px-5 py-8 text-center sm:px-6 sm:py-10" data-id="element-41" data-mp="2zqjc21zx12ri">
            <h2 id="checkout-heading" className="font-display text-xl font-extrabold uppercase leading-tight tracking-[-0.02em] text-white sm:text-2xl lg:text-3xl" data-id="element-42" data-mp="2vpha3dem6clu">
              The Blues Teacher’s Arsenal™ — Complete System
            </h2>
            <p className="mt-3 font-display text-sm font-bold text-gold sm:text-base" data-id="element-43" data-mp="tw9u01r6fqyw">
              6 Volumes + 5 Strategic Bonuses
            </p>
          </div>

          <div className="px-5 py-10 sm:px-10 lg:px-14" data-id="element-44" data-mp="2jc5s9ewzwkvd">
            <img src={heroMockup} alt="Everything included: the six volumes, the digital editions and the five bonuses" className="mx-auto w-full max-w-2xl" width={1671} height={933} data-id="element-45" data-mp="25bv1ebvor6a7" />

            <hr className="my-8 border-slate-200 sm:my-10" data-id="element-46" data-mp="2x4ucukwyscdt" />

            <p className="text-center font-display text-[11px] font-extrabold uppercase tracking-[0.2em] text-gold-deep sm:text-xs" data-id="element-47" data-mp="320sza2yqfkbl">
              What’s included
            </p>

            <ul className="mx-auto mt-7 grid max-w-2xl gap-x-10 gap-y-4 sm:grid-cols-2 sm:gap-y-5" data-id="element-48" data-mp="2sbj6slzz7zmy">
              {checkoutChecklist.map(item => <li key={item} className="flex items-start gap-3" data-id="element-49" data-mp="3fzish7ifkzuo">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold/20" data-id="element-50" data-mp="3kt591arptnvr">
                    <CheckIcon className="h-3.5 w-3.5 text-gold-deep" aria-hidden="true" strokeWidth={3} data-id="element-51" data-mp="3unj725bkw77h" />
                  </span>
                  <span className="font-display text-[15px] font-bold leading-snug text-navy" data-id="element-52" data-mp="3lpqmomr029d8">
                    {item}
                  </span>
                </li>)}
            </ul>

            <hr className="my-8 border-slate-200 sm:my-10" data-id="element-53" data-mp="3braxwqfg3c6w" />

            <div className="text-center" data-id="element-54" data-mp="36xyagjmi5bfq">
              <p className="text-[11px] uppercase tracking-[0.16em] text-slate-400" data-id="element-55" data-mp="36wwx28i0kcuu">
                Total real value <span className="line-through" data-id="element-56" data-mp="2xy1sf0umbatn">{realValueLabel}</span>
              </p>
              <div className="mt-3 flex flex-wrap items-end justify-center gap-x-3 gap-y-1" data-id="element-57" data-mp="2xvyvdwv1shff">
                <span className="font-display text-5xl font-extrabold leading-none tracking-[-0.04em] text-navy sm:text-7xl" data-id="element-58" data-mp="2t12xwh71l1ux">
                  {priceLabel}
                </span>
                <span className="pb-1 text-xs uppercase tracking-[0.14em] text-slate-500 sm:pb-2" data-id="element-59" data-mp="2dvfbfs35orm1">
                  USD · price today
                </span>
              </div>
              <p className="mt-4 inline-flex rounded-md bg-gold/20 px-3 py-1.5 font-display text-[11px] font-extrabold uppercase tracking-[0.1em] text-gold-deep sm:text-xs" data-id="element-60" data-mp="2nv67vzba1gor">
                {savingsLabel}
              </p>

              <div className="mt-7" data-id="element-61" data-mp="1v70jn2l0l9k6">
                <CtaButton label="Yes, I want the system" size="lg" fullWidth data-id="element-62" data-mp="204k1sdku26he" />
              </div>

              <p className="mt-3 text-[13px] text-slate-500" data-id="element-63" data-mp="253n3bo1ltukm">{localCurrencyNote}</p>

              <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-slate-500" data-id="element-64" data-mp="251sie9qc22gj">
                <li className="flex items-center gap-2" data-id="element-65" data-mp="1cf7rtbholue1">
                  <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-66" data-mp="1cepojuwlqfwm" /> Secure payment
                </li>
                <li className="flex items-center gap-2" data-id="element-67" data-mp="1hby922582w11">
                  <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-68" data-mp="3j49tc7wa2zx0" /> Instant access
                </li>
                <li className="flex items-center gap-2" data-id="element-69" data-mp="3e56qmu3rt5s7">
                  <CreditCardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-70" data-mp="3st1jqbloxc5t" /> Card · GPay · Apple
                  Pay
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}